// extracted by mini-css-extract-plugin
export default {"logos":"style_logos__RhCQN","grandaLogo":"style_grandaLogo__Pu46W","socialmedia":"style_socialmedia__0Zig-"};